import api from './api'
import { equals, map, prop, reduce, values } from 'ramda'

const interviews = $http => {
  'ngInject'

  const getAll = (region) => {
    return $http({
      method: 'GET',
      url: `${api.getBase()}/interviews/getAll`,
      params: {
        region: region || null
      }
    })
    .then(res => {
      var interviews = res.data
      return interviews.sort((a, b) => {
        return a.start_date_time > b.start_date_time ? 1 : -1
      })
    })
    .then(item => map(setNumOnJob, item))
  }

  const setNumOnJob = (interview) => {
    let pplOnJob = 0
    let passedInterview = 0
    if (interview.attachedUsers) {
      pplOnJob = reduce((a, b) => {
        if (equals(b.status, 0)) return a + 1
        return a
      }, 0, values(interview.attachedUsers))
      passedInterview = reduce((a, b) => {
        if (equals(b.status, 11)) return a + 1
        return a
      }, 0, values(interview.attachedUsers))
    }
    interview.passedInterview = passedInterview
    interview.pplOnJob = pplOnJob
    return interview
  }

  return {
    getAll,
  }
}

export default interviews
